module.exports = __webpack_public_path__ + "img/eye-close.158c8973.svg";